export default __webpack_public_path__ + "static/media/man_standing.0e489b3d.png";